import { fromJsonArray } from 'src/core/utils';
import Video from 'src/entities/video/Video';

export type VideoRatingState = 'none_rateable' | 'none_rated' | 'some_rated' | 'all_rated';

export const ColorMapVideoRatingState: Record<VideoRatingState, ContextColor> = {
    none_rateable: 'neutral',
    none_rated: 'error',
    some_rated: 'warning',
    all_rated: 'success',
};

export default class VideoCategory {
    public readonly id: string;
    public readonly normalizedName: string;
    public readonly sortOrder: number;
    public readonly localizedName: string;
    public readonly videos: Video[];
    public readonly rateableCount: number;

    constructor(json: any) {
        this.id = json.id;
        this.normalizedName = json.normalizedName;
        this.sortOrder = json.sortOrder;
        this.localizedName = json.localizedName;
        this.videos = fromJsonArray(Video, json.videos);
        this.rateableCount = json.rateableCount;
    }

    public get videoCount(): number {
        return this.videos.length;
    }

    public get ratedVideoCount(): number {
        return this.videos.filter(v => v.isRated).length;
    }

    public get ratingState(): VideoRatingState {
        const c = this.rateableCount;
        const r = this.ratedVideoCount;

        if (c <= 0) return 'none_rateable';
        if (r <= 0) return 'none_rated';
        if (r < c) return 'some_rated';
        return 'all_rated';
    }

    public containsUnratedVideo(): boolean {
        return this.videos.some(v => !v.isRated);
    }

    static extractCategoryOfFirstUnrated(categories: VideoCategory[]): VideoCategory | undefined {
        return categories.find(c => c.containsUnratedVideo());
    }
}
